import { Component, OnInit } from '@angular/core';
import { DistribuidorDeContenidosService } from '../servicio/distribuidor-de-contenidos.service';


@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {
  titulo: string
  descripcion: string
  subtituloA: string
  subtituloB: string
  texto: string
  datosContacto: { contacto: string; }[];

  constructor(private distribuidor: DistribuidorDeContenidosService) {
    this.titulo = distribuidor.contenidoContacto.titulo
    this.descripcion = distribuidor.contenidoContacto.descripcion
    this.subtituloA = distribuidor.contenidoContacto.subtituloA
    this.subtituloB = distribuidor.contenidoContacto.subtituloB
    this.texto = distribuidor.contenidoContacto.texto
    this.datosContacto = distribuidor.contenidoContacto.datosContacto
  }

  ngOnInit(): void {

  }

}
